import { makeStyles } from '@material-ui/core';
import logo from '../theme/TotalEnergies-logo.png';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 72,
    display: 'block',
  },
});

// Compact TotalEnergies logo, shown when the sidebar is collapsed. Same colour
// asset as the full logo (identical in both themes), rendered a bit smaller.
export const LogoIcon = () => {
  const classes = useStyles();
  return <img className={classes.img} src={logo} alt="TotalEnergies" />;
};
